<app-spinner-service></app-spinner-service>

<app-toolbar-search 
  [showDateFilters]="true" 
  [showDownloadButton]="true" 
  [(dataInicio)]="dataInicio"
  [(dataFim)]="dataFim" 
  (onDateChange)="onDateChange()" 
  (onDownload)="downloadExcel()"
  (onSearch)="applyFilterGlobal($event)" 
  placeholder="Pesquisar balancete...">
</app-toolbar-search>

<p-table #dt 
  [value]="contasBalancete" 
  [paginator]="true" 
  [rows]="50"
  [globalFilterFields]="['codigo', 'descricao', 'saldoAnterior', 'naturezaSaldoAnterior', 'debito', 'credito', 'saldoAtual', 'naturezaSaldo']"
  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
  class="custom-table"
  [loading]="loading"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[5, 10, 20, 50]">

  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="codigo" style="width: 12%">
        Código <p-sortIcon field="codigo"></p-sortIcon>
      </th>
      <th pSortableColumn="descricao" style="width: 25%">
        Descrição <p-sortIcon field="descricao"></p-sortIcon>
      </th>
      <th pSortableColumn="saldoAnterior" style="width: 12%">
        Saldo Anterior <p-sortIcon field="saldoAnterior"></p-sortIcon>
      </th>
      <th pSortableColumn="naturezaSaldoAnterior" style="width: 10%">
        Natureza Saldo Anterior <p-sortIcon field="naturezaSaldoAnterior"></p-sortIcon>
      </th>
      <th pSortableColumn="debito" style="width: 12%">
        Débito <p-sortIcon field="debito"></p-sortIcon>
      </th>
      <th pSortableColumn="credito" style="width: 12%">
        Crédito <p-sortIcon field="credito"></p-sortIcon>
      </th>
      <th pSortableColumn="saldoAtual" style="width: 12%">
        Saldo Atual <p-sortIcon field="saldoAtual"></p-sortIcon>
      </th>
      <th pSortableColumn="naturezaSaldo" style="width: 5%">
        Natureza Saldo Atual <p-sortIcon field="naturezaSaldo"></p-sortIcon>
      </th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-conta>
    <tr>
      <td>
        <div class="code-content">
          <i class="pi pi-tag code-icon"></i>
          <span class="code-text" [pTooltip]="conta.codigo" tooltipPosition="top">{{ conta.codigo }}</span>
        </div>
      </td>
      <td>
        <div class="description-content">
          <i class="pi pi-align-left description-icon"></i>
          <span class="description-text" [pTooltip]="conta.descricao" tooltipPosition="top">{{ conta.descricao }}</span>
        </div>
      </td>
      <td>
        <div class="value-content">
          <i class="pi pi-dollar value-icon"></i>
          <span class="value-text" [pTooltip]="formataValorPositivoHelper.formatarSaldoPositivo(conta.saldoAnterior) | currency:'BRL':'symbol':'1.2-2'" tooltipPosition="top">{{ formataValorPositivoHelper.formatarSaldoPositivo(conta.saldoAnterior) | currency:'BRL':'symbol':'1.2-2' }}</span>
        </div>
      </td>
      <td>
        <div class="nature-content" *ngIf="conta.saldoAnterior !== 0">
          <i class="pi pi-info-circle nature-icon"></i>
          <span class="nature-text" [pTooltip]="conta.descricaoTipoTransacaoSaldoAnterior" tooltipPosition="top">{{ conta.descricaoTipoTransacaoSaldoAnterior }}</span>
        </div>
      </td>
      <td>
        <div class="debit-content">
          <i class="pi pi-minus-circle debit-icon"></i>
          <span class="debit-text" [pTooltip]="formataValorPositivoHelper.formatarSaldoPositivo(conta.debito) | currency:'BRL':'symbol':'1.2-2'" tooltipPosition="top">{{ formataValorPositivoHelper.formatarSaldoPositivo(conta.debito) | currency:'BRL':'symbol':'1.2-2' }}</span>
        </div>
      </td>
      <td>
        <div class="credit-content">
          <i class="pi pi-plus-circle credit-icon"></i>
          <span class="credit-text" [pTooltip]="formataValorPositivoHelper.formatarSaldoPositivo(conta.credito) | currency:'BRL':'symbol':'1.2-2'" tooltipPosition="top">{{ formataValorPositivoHelper.formatarSaldoPositivo(conta.credito) | currency:'BRL':'symbol':'1.2-2' }}</span>
        </div>
      </td>
      <td>
        <div class="balance-content">
          <i class="pi pi-calculator balance-icon"></i>
          <span class="balance-text" [pTooltip]="formataValorPositivoHelper.formatarSaldoPositivo(conta.saldoAtual) | currency:'BRL':'symbol':'1.2-2'" tooltipPosition="top">{{ formataValorPositivoHelper.formatarSaldoPositivo(conta.saldoAtual) | currency:'BRL':'symbol':'1.2-2' }}</span>
        </div>
      </td>
      <td>
        <div class="nature-content" *ngIf="conta.saldoAtual !== 0">
          <i class="pi pi-info-circle nature-icon"></i>
          <span class="nature-text" [pTooltip]="conta.descricaoTipoTransacaoSaldoAtual" tooltipPosition="top">{{ conta.descricaoTipoTransacaoSaldoAtual }}</span>
        </div>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8" class="empty-message">
        <div class="empty-content">
          <i class="pi pi-chart-bar" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
          <h3>Nenhum balancete encontrado</h3>
          <p>Não há dados de balancete para o período selecionado.</p>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<div class="p-d-flex p-jc-end" style="margin-top: 1%;">
  <button pButton label="Voltar" icon="pi pi-arrow-left" class="p-button-secondary" (click)="voltar()"></button>
</div>